/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2023-05-29 10:25:33
 * @LastEditTime: 2025-11-28 14:05:06
 */
import arrowRight from '../../images/arrow-right.svg';

const MatchInfo = () => {
  return (
    <>
      <div
        className='jury__line outlineTitle'
        style={{
          textAlign: 'center',
          marginBottom: '60px',
          marginTop: '128px',
        }}
      >
        <label className={`enter_label  active `}>大赛简介</label>
      </div>
      <div className='home-row row-padding'>
        <div className='home-v2-infoSummary'>
        为进一步贯彻落实党的二十大和二十届历次全会精神，深入贯彻落实习近平总书记关于知识产权工作的重要指示论述精神以及习近平总书记在龙江视察期间的重要讲话重要指示精神，大力实施国务院办公厅《专利转化运用专项行动方案（2023—2025年）》，加速推进“科技成果产业化突破年”“服务企业效能提升突破年”“县域经济发展突破年”任务目标落实落地，黑龙江省举办首届“龙知交”高价值专利运营大赛，挖掘和培育一批具有市场潜力和产业带动性的高价值专利，探索出一套可复制可推广的高价值专利运营转化路径，助力实体经济做强做优，为因地制宜培育新质生产力增添新动能，为龙江高质量发展提供有力支撑。
        </div>
      </div>
      <div className='home-row'>
        <div
          onClick={() => {
            window.location.href = '/schedule';
          }}
          className='link-detail container-linkDetail'
        >
          <img src={arrowRight} />
          了解大赛详情
        </div>
      </div>
      {/* <div className="home-row" style={{ marginTop: '64px' }}>
        <div className="home-v2-unit">主办单位</div>
        <div className="home-v2-unit">承办单位</div>
      </div>
      <div
        className="home-row"
        style={{ marginTop: '24px', justifyContent: 'space-between' }}
      >
        <div className="home-v2-unitLogo">
          <img src={unit1} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit2} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit3} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit4} />
        </div>
      </div>
      <div
        className="home-row"
        style={{ marginTop: '24px', justifyContent: 'space-between' }}
      >
        <div className="home-v2-text">上海市知识产权局</div>
        <div className="home-v2-text">上海市科学技术委员会</div>
        <div className="home-v2-text">上海技术交易所</div>
        <div className="home-v2-text">上海市高校科技发展中心</div>
      </div> */}
    </>
  );
};

// @ts-ignore
export default MatchInfo;
